import type { MRT_ColumnDef } from '@brightdrop/table-ui';
import { Box } from '@mui/system';
import type { BatchSummaryVehicleBoardingSession } from '~/api/generated-api';
import { translateText } from '~/common/components/TranslatedLabel/TranslatedLabel';
import { DEFAULT_EMPTY_VALUE } from '~/common/constants/common.constant';
import { BatchSessionReasonCodeEnum } from '~/common/models/asset.model';

const VIN_COLUMN_DEF = (): MRT_ColumnDef<
  BatchSummaryVehicleBoardingSession,
  string
> => ({
  accessorKey: 'vin',
  header: translateText('asset:vin'),
  Cell: (props) => {
    const vin = props.cell.getValue() || DEFAULT_EMPTY_VALUE;
    return <Box>{vin}</Box>;
  },
});

const REASON_COLUMN_DEF = (): MRT_ColumnDef<
  BatchSummaryVehicleBoardingSession,
  string
> => ({
  accessorKey: 'reasonCode',
  header: translateText('common:details'),
  Cell: (props) => {
    const cellValue = props.cell.getValue();
    const reasonCodeValid = Object.values(BatchSessionReasonCodeEnum).includes(
      cellValue as BatchSessionReasonCodeEnum
    );
    const reason = reasonCodeValid
      ? translateText(
          `asset:batchSummaryView.batchSummaryList.reasonCode.${cellValue}`
        )
      : DEFAULT_EMPTY_VALUE;
    return <Box>{reason}</Box>;
  },
  // have to set the size of reason column to shrink the VIN column
  size: 330,
});

export const getFailedVehicleListColumns = (): MRT_ColumnDef<
  BatchSummaryVehicleBoardingSession,
  string
>[] => {
  return [VIN_COLUMN_DEF(), REASON_COLUMN_DEF()];
};
